/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Keen_Still_Crane_GazeInputs */

const en_keen_still_crane_gaze = /** @type {(inputs: Keen_Still_Crane_GazeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exactly ${i?.value}%`)
};

const de_keen_still_crane_gaze = /** @type {(inputs: Keen_Still_Crane_GazeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genau ${i?.value}%`)
};

/**
* | output |
* | --- |
* | "Exactly {value}%" |
*
* @param {Keen_Still_Crane_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_still_crane_gaze = /** @type {((inputs: Keen_Still_Crane_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Still_Crane_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_still_crane_gaze(inputs)
	return de_keen_still_crane_gaze(inputs)
});